// extracted by css-extract-rspack-plugin
export default {"cls1":"ActiveState-cls1_opy","cls2":"ActiveState-cls2_DHy ActiveState-cls1_opy","isDisabled":"ActiveState-isDisabled_z6w"};